// Generic "Unverify Property/Entity" dialog — same shape trackRecordProperties.tsx
// and trackRecordEntities.tsx each hand-roll, just with a different title.
import { useEffect, useState } from 'react';
import { FormControl, Grid, TextField, Typography } from '@material-ui/core';
import { Button, StandardDialog } from '@roc/ui';
import { useCenteredDialogStyles } from './centeredDialogStyles';

export const UnverifyRecordDialog = ({
  open,
  title,
  recordLabel,
  onClose,
  onConfirm,
}: {
  open: boolean;
  title: string;
  recordLabel: string;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}) => {
  const dialogClasses = useCenteredDialogStyles();
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (open) setReason('');
  }, [open]);

  return (
    <StandardDialog
      classes={{ paper: dialogClasses.paper, container: dialogClasses.container }}
      open={open}
      maxWidth="sm"
      title={title}
      handleClose={onClose}
      dialogContent={
        <Grid container direction="column">
          <Grid>
            <Typography>Please specify the reason:</Typography>
            <FormControl style={{ width: '100%', marginBottom: 16, paddingRight: 64 }}>
              <TextField variant="outlined" value={reason} onChange={(event) => setReason(event.target.value)} />
            </FormControl>
            <Typography variant="body1">Are you sure you want to mark this {recordLabel} as unverified?</Typography>
          </Grid>
        </Grid>
      }
      dialogActions={
        <Grid container direction="row" justifyContent="flex-end">
          <Button testId="cancelUnverifyRecord" style={{ marginRight: 10 }} onClick={onClose}>
            Cancel
          </Button>
          <Button testId="confirmUnverifyRecord" disabled={!reason} color="primary" variant="outlined" onClick={() => onConfirm(reason)}>
            Unverify
          </Button>
        </Grid>
      }
    />
  );
};
